import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const TrashView = lazy(async () => {
  const m = await import("@/features/trash/components/trash-view");
  return { default: m.TrashView };
});

/**
 * ACTIVITY-CORE (L2) — trash: restore products/warehouses/locations/
 * operations. No "permanently delete": the trail is never destroyed.
 */
export const trashRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/trash",
  component: () => (
    <Suspense fallback={null}>
      <TrashView />
    </Suspense>
  ),
});
